"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CapacCenTrab = void 0;
var bson_1 = require("bson");
var CapacCenTrab = /** @class */ (function () {
    function CapacCenTrab(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.CD_FABRICA, CD_FABRICA = _c === void 0 ? '' : _c, _d = _a.NODE, NODE = _d === void 0 ? '' : _d, _e = _a.CENTRO_TRAB, CENTRO_TRAB = _e === void 0 ? '' : _e, _f = _a.CENTRO, CENTRO = _f === void 0 ? '' : _f, _g = _a.DT_VAL_INI, DT_VAL_INI = _g === void 0 ? '' : _g, _h = _a.DT_VAL_FIM, DT_VAL_FIM = _h === void 0 ? '' : _h, _j = _a.CAPACIDADE_MAX, CAPACIDADE_MAX = _j === void 0 ? 0 : _j, _k = _a.UN, UN = _k === void 0 ? '' : _k;
        this._id = _id;
        this.CD_FABRICA = CD_FABRICA;
        this.NODE = NODE;
        this.CENTRO_TRAB = CENTRO_TRAB;
        this.CENTRO = CENTRO;
        this.DT_VAL_INI = DT_VAL_INI;
        this.DT_VAL_FIM = DT_VAL_FIM;
        this.CAPACIDADE_MAX = CAPACIDADE_MAX;
        this.UN = UN;
    }
    return CapacCenTrab;
}());
exports.CapacCenTrab = CapacCenTrab;
//# sourceMappingURL=CapacCenTrab.js.map